import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";

export default function UserStatusToggle() {
  const { login } = useParams<{ login: string }>();
  const history = useHistory();

  // État simulé : à récupérer via votre API (ex: UserService.get)
  const [isActive, setIsActive] = useState(true);
  const userName = "Jean Dupont"; // Simulé

  return (
    <div className="flex flex-col items-center justify-center p-4 w-full min-h-screen">
      <div className="w-full max-w-lg">
        <div className="relative bg-[#0B1222] border border-white/10 rounded-[2rem] shadow-2xl overflow-hidden p-8 lg:p-12 text-center">
          {/* CERCLE D'ÉTAT DYNAMIQUE */}
          <div className="relative mx-auto w-24 h-24 mb-8">
            <div
              className={`absolute inset-0 rounded-full blur-2xl opacity-20 animate-pulse ${isActive ? "bg-green-500" : "bg-red-500"}`}
            ></div>
            <div
              className={`relative w-24 h-24 rounded-full border-2 flex items-center justify-center text-3xl transition-colors duration-500 ${
                isActive
                  ? "border-green-500/50 bg-green-500/10 text-green-500"
                  : "border-red-500/50 bg-red-500/10 text-red-500"
              }`}
            >
              <i
                className={`fas ${isActive ? "fa-user-check" : "fa-user-slash"}`}
              ></i>
            </div>
          </div>

          {/* TEXTES DE CONFIRMATION */}
          <h2 className="text-white text-xl font-black uppercase tracking-tighter mb-2">
            {isActive ? "Désactiver l'accès ?" : "Réactiver l'accès ?"}
          </h2>
          <p className="text-slate-500 text-xs font-bold uppercase tracking-widest mb-8">
            Utilisateur : <span className="text-[#D4AF37]">{login}</span> (
            {userName})
          </p>

          <div className="bg-[#161F32]/50 border border-white/5 rounded-2xl p-6 mb-10">
            <p className="text-[11px] text-slate-400 leading-relaxed font-medium">
              {isActive
                ? "En désactivant ce compte, l'utilisateur ne pourra plus se connecter aux services. Ses données resteront conservées dans la base de données."
                : "La réactivation permettra à l'utilisateur de retrouver l'intégralité de ses accès avec ses identifiants actuels."}
            </p>
          </div>

          {/* ACTIONS ACTIONS */}
          <div className="flex flex-col gap-4">
            <button
              onClick={() => setIsActive(!isActive)}
              className={`w-full py-4 rounded-xl font-black text-[10px] uppercase tracking-[0.3em] transition-all transform active:scale-95 shadow-lg ${
                isActive
                  ? "bg-red-500/10 border border-red-500/20 text-red-500 hover:bg-red-500 hover:text-white shadow-red-500/10"
                  : "bg-green-500/10 border border-green-500/20 text-green-500 hover:bg-green-500 hover:text-white shadow-green-500/10"
              }`}
            >
              Confirmer la {isActive ? "Désactivation" : "Réactivation"}
            </button>

            <button
              onClick={() => history.goBack()}
              className="w-full py-4 text-[10px] font-black uppercase tracking-widest text-slate-500 hover:text-white transition-colors"
            >
              Annuler et retourner à la liste
            </button>
          </div>

          {/* DÉCORATION SUBTILE */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent"></div>
        </div>
      </div>
    </div>
  );
}
